module.exports = __webpack_public_path__ + "static/assets/15168879152e149b709100995242e833.png";